import React from 'react';
import ReactTooltip from 'react-tooltip';
import './Tooltip.css';

const CustomTooltip = ({
	children,
	content,
	placement = 'top',
	delay = 300,
	id,
}) => {
	const tooltipId = id || `tooltip-${Math.random().toString(36).substr(2, 9)}`;

	return (
		<>
			<div
				data-tip={content}
				data-for={tooltipId}
				data-delay-show={delay}
				data-place={placement}
				data-effect="solid"
				style={{
					display: 'inline-flex',
					alignItems: 'center',
					justifyContent: 'center',
					position: 'relative',
				}}
			>
				{children}
			</div>
			<ReactTooltip
				id={tooltipId}
				place={placement}
				effect="solid"
				delayShow={delay}
				style={{
					backgroundColor: 'rgba(0, 0, 0, 0.9) !important',
					color: 'white !important',
					borderRadius: '4px',
					padding: '6px 8px',
					fontSize: '12px',
					fontWeight: '400',
					maxWidth: '200px',
					wordWrap: 'break-word',
					zIndex: 1050,
					boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
				}}
				className="custom-tooltip"
			/>
		</>
	);
};

export default CustomTooltip;
